import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {openCategory, toggleCategory} from '../../modules/admin/docs';
import styles from './styles/expand-side-bar.module.css';

import Loading from '../common/Loading';
import MessageBox from '../common-women/MessageBox';

import {ReactComponent as Error} from '../../assets/docs-women/error.svg';
import {ReactComponent as AllCategory} from '../../assets/side-bar/all-category.svg';
import {ReactComponent as ArrowDown} from '../../assets/side-bar/arrow-down.svg';
import {ReactComponent as ArrowUp} from '../../assets/side-bar/arrow-up.svg';
import {ReactComponent as MainCategory} from '../../assets/side-bar/main-category.svg';
import {ReactComponent as SubCategory} from '../../assets/side-bar/sub-category.svg';

const Item = ({ type, currentId, category = {}, changeCurrentId, isOpen }) => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { id, categoryName } = category;

    const isSelected =          // 선택된 카테고리 활성화된 CSS를 위한 변수 
        (currentId === 0 && type === 'all') ||
        (id === currentId);

    const clickDropdown = () => {
        dispatch(toggleCategory(id));
    };

    const clickItem = (e) => { // 스토어에 있는 currentId를 업데이트하고 URL을 변경하고 드롭다운을 열기만 하는 함수
        e.stopPropagation();

        const clickedId = type === 'all' ? 0 : id;

        changeCurrentId(clickedId);
        navigate(`/admin/docs/${clickedId}`);

        if (type === 'main') {
            dispatch(openCategory(id));
        }
    };

    return (
        <div
            className={`${styles.boxItem} ${isSelected ? styles.selected : ''}`}
            datatype={type}
        >
            {type === 'main' && 
                <div onClick={clickDropdown}>{isOpen ? <ArrowUp /> : <ArrowDown />}</div>
            }
            <div>
                {type === 'all' && <AllCategory />}
                {type === 'main' && <MainCategory />}
                {type === 'sub' && <SubCategory />}
            </div>
            <p onClick={clickItem}>
                {type === 'all' ? '모든 카테고리' : categoryName}
            </p>
        </div>
    );
};

const MainItem = ({ currentId, category, changeCurrentId }) => {
    const { id, categoryList } = category;

    const { openCategoryList } = useSelector(({ docs }) => ({
        openCategoryList: docs.openCategoryList
    }));

    const isOpen = openCategoryList.includes(id);

    return (
        <div className={styles.boxMainItem}>
            <Item
                type='main'
                currentId={currentId}
                category={category}
                changeCurrentId={changeCurrentId}
                isOpen={isOpen}
            />
            
            {/* 하위 카테고리 목록 */}
            {isOpen && categoryList && <>
                {categoryList.map((subCategory) => (
                    <Item
                        key={subCategory.id}
                        type='sub'
                        currentId={currentId}
                        category={subCategory}
                        changeCurrentId={changeCurrentId}
                    />
                ))}
            </>}
        </div>
    );
};

export default function ExpandSideBar({ currentId, response, error, loading, changeCurrentId, handleReload }) {
    const containerRef = useRef(null);
    
    const [isBottom, setIsBottom] = useState(false);
    
    const checkScrollPosition = () => {
        if (containerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
            setIsBottom(scrollHeight - scrollTop - clientHeight < 5);
        }
    };

    const handleScroll = () => {
        checkScrollPosition();
    };
    
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            checkScrollPosition();
        }
            
        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return (
        <div className={styles.wrapper}>
            <Item
                type='all'
                currentId={currentId}
                changeCurrentId={changeCurrentId}
            />

            <div className={styles.container} ref={containerRef}>
                {loading && <Loading />}

                {!loading && response && response.map((category) => (
                    <MainItem
                        key={category.id}
                        currentId={currentId}
                        category={category}
                        changeCurrentId={changeCurrentId}
                    />
                ))}

                {!loading && error &&
                    <MessageBox
                        height='95%'
                        Icon={Error}
                        message={<>페이지를 불러오는 중 <span style={{ color: 'red' }}>오류</span> 발생</>}
                        subMessage='재시도'
                        handleReload={handleReload}
                    />
                }

                {!isBottom && <div className={styles.fadeEffect} />}
            </div>
        </div>
    );
}
